// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dece2e673c--wrapper--QziY5"};